import {mapMutations, mapState} from 'vuex';

import Modal from '../../components/modals/base/Modal.vue';
import ModalHeaders from '../../components/modals/base/ModalHeaders.vue';
import ModalHeader from '../../components/modals/base/ModalHeader.vue';

export default {
    components: {
        'modal': Modal,
        'modal-headers': ModalHeaders,
        'modal-header': ModalHeader,
    },

    data() {
        return {
            active_tab: 'main',
        };
    },

    computed: {
        ...mapState('modal',
            ['popup_open', 'popup_name', 'popup_data']),
    },

    methods: {
        ...mapMutations('modal',
            ['togglePopup']),

        setModalTab(tab) {
            this.active_tab = tab;
        },

        openPopup(name, data) {
            this.togglePopup({name, data});
        },

        closePopup() {
            this.togglePopup();
        },

        validateModal(closeOnSuccess = true) {
            const self = this;

            return new Promise((resolve, reject) => {
                if (this.$refs[`modal-${this.popup_name}`]) {
                    this.$refs[`modal-${this.popup_name}`].validate().then((success) => {
                        if (success) {
                            resolve(true);

                            if (closeOnSuccess) {
                                this.closePopup();
                            }
                        } else {
                            setTimeout(() => {
                                const errors = Object.entries(self.$refs[`modal-${this.popup_name}`].errors)
                                    .map(([key, value]) => ({key, value}))
                                    .filter(error => error.value.length);
                                self.$refs[`modal-${this.popup_name}`].refs[errors[0].key].$el.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                });
                            }, 100);

                            reject(new Error('not valid'));
                        }
                    });
                } else {
                    resolve(true);

                    if (closeOnSuccess) {
                        this.closePopup();
                    }
                }
            });
        },
    },
};
